import { Close } from "@mui/icons-material";
import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Popover, Select, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const SortModelButton = (props) => {
    const { columns, sortModel, onChangeSortModel, children } = props;

    const [anchorEl, setAnchorEl] = useState(null);
    const [column, setColumn] = useState("");
    const [sortBy, setSortBy] = useState("asc");

    useEffect(() => {
        if (sortModel?.length > 0) {
            if (sortModel[0]?.field) setColumn(sortModel[0]?.field);
            if (sortModel[0]?.sort) setSortBy(sortModel[0]?.sort);
        }
    }, [sortModel]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };
    
    const open = Boolean(anchorEl);

    const handleChangeColumn = (event) => {
        setColumn(event.target.value);
        onChangeSortModel?.([{ field: event.target.value, sort: sortBy }]);
    };

    const handleChangeSortBy = (event) => {
        setSortBy(event.target.value);
        onChangeSortModel?.([{ field: column, sort: event.target.value }]);
    };

    const handleClearSort = () => {
        setColumn("");
        setSortBy("");
        onChangeSortModel?.([]);
    }

    return (
        <>
            <Button onClick={handleClick}>
                {children}
            </Button>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Box className="flex gap-4 items-end min-w-[250px] p-4">
                    <IconButton onClick={handleClearSort} className="" size="small">
                        <Close />
                    </IconButton>
                    <FormControl sx={{ minWidth: 120 }} variant="standard">
                        <InputLabel>Column</InputLabel>
                        <Select
                            value={column}
                            label="Column"
                            onChange={handleChangeColumn}
                            sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px'}}
                        >
                            <MenuItem sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px'}} value="">
                                <em>Select</em>
                            </MenuItem>
                            {columns?.filter((item) => item.sortable !== false)?.map((item) => (
                                <MenuItem sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px'}} key={item.field} value={item.field}>{item.headerName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{ minWidth: 120 }} variant="standard">
                        <InputLabel>Sort By</InputLabel>
                        <Select
                            value={sortBy}
                            label="Sort By"
                            onChange={handleChangeSortBy}
                            sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px'}}
                        >
                            {/* <MenuItem sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px'}} value="">
                                <em>Select</em>
                            </MenuItem> */}
                            <MenuItem sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px'}} value={"asc"}>Ascending</MenuItem>
                            <MenuItem sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px'}} value={"desc"}>Descending</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Popover>
        </>
    );
}

export default SortModelButton;